export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13475.ef5a0c89.jpg";